import { createApp } from 'vue'
import App from './App.vue'
// import VConsole from 'vconsole';

// new VConsole({ theme: 'dark' });

createApp(App).mount('#app')
